const OnEdit = function() {
  const ids = this.collection.selected_rows
  alert(`It will edit ${ids.join(",")}`)
}
export default OnEdit